<template>
  <div>
    <b-button
      v-if="renderButton"
      :id="popoverTargetId"
    >
      Assign Users and Groups
    </b-button>
    <div v-else>
      <font-awesome-icon
        :id="popoverTargetId"
        title="Users"
        class="text-primary action-button mr-2 ml-auto"
        :icon="['fas', 'users']"
        @click.stop
      />
    </div>
    <b-popover
      :id="`users-popover-${componentId}`"
      ref="popover"
      class="popover"
      :custom-class="!isSinglePage ? 'mh-200' : ''"
      :target="popoverTargetId"
      placement="top"
      triggers="click blur"
      @hidden="onModalHidden"
      @shown="onModalShown"
    >
      <template #title>
        Search for Users and Groups
      </template>
      <div class="p-2">
        <input
          id="searchUsersInput"
          ref="usersSearchInput"
          v-model="keyword"
          v-debounce="searchForUsers"
          class="form-control"
          placeholder="Type to search for users and Groups"
        >
      </div>
      <b-alert
        show
        variant="info"
      >
        The list below displays the first 100 users and groups in alphabetical order.
        If you're looking for a specific user or group, please enter your search criteria to find them.
      </b-alert>
      <div
        v-if="isLoading"
        class="text-center p-3"
      >
        <b-spinner
          small
          type="grow"
          variant="primary"
        />
        <span class="ml-2">Loading...</span>
      </div>
      <div
        v-else
      >
        <b-list-group-item
          v-for="user in users.data"
          :id="`user-id-'${user.id}'`"
          button
          class="d-flex align-items-center search-users-option"
          @click="userSelect(user)"
        >
          <b-avatar
            variant="primary"
            :text="getAvatarText(user)"
            class="mr-3"
          />
          <span class="mr-auto">{{ user.displayName }}</span>
          <font-awesome-icon
            v-if="selectedUsers.indexOf(user.id) > -1"
            class="text-success"
            :icon="['fas', 'check']"
          />
        </b-list-group-item>
      </div>
    </b-popover>
  </div>
</template>

<script>
import {createNamespacedHelpers} from 'vuex';

const {mapActions: mapActionsUser, mapState: mapStateUsers} = createNamespacedHelpers('user');
export default {
  name: 'UserListPopover',
  props: {
    selectedUsers: {
      type: Array,
      default: () => [],
    },
    isSinglePage: {
      type: Boolean,
      default: true,
    },
    componentId: {
      type: String,
      default: null,
    },
    renderButton:{
      type: Boolean,
      default: true,
    },
    finishEditing: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      keyword: '',
      isLoading: false,
    };
  },
  computed: {
    ...mapStateUsers(['users']),
    popoverTargetId() {
      return this.isSinglePage ? 'assignUsers' : `usersPopoverButton${this.componentId}`;
    },
    // filteredUsers() {
    //   return this.keyword ? this.users.filter(user => user.displayName.toLowerCase().includes(this.keyword.toLowerCase())) : this.users
    // },
  },
  methods: {
    ...mapActionsUser(['getUsersAndGroups']),
    getAvatarText(user) {
      return user.displayName.split(' ').map(el => el[0] ? el[0].toUpperCase() : '').join('');
    },
    userSelect(user) {
      this.$refs.popover.$emit('close');
      if (this.selectedUsers.indexOf(user.id) > -1) {
        this.$emit('userRemove', user);
      } else {
        this.$emit('userSelect', user);
      }
    },
    async onModalShown() {
      await this.search();
      if(this.$refs.usersSearchInput){
        this.$refs.usersSearchInput.focus();
      }
    },
    async onModalHidden() {
      this.keyword = '';
      if(this.renderButton){
        await this.search();
      }
      if (this.finishEditing) {
        this.finishEditing();
      }
    },
    async searchForUsers() {
      await this.search();
    },
    async search(){
      this.isLoading = true;
      await this.getUsersAndGroups(this.keyword);
      this.isLoading = false;
    },
  },
};
</script>

<style lang="scss">
.mh-200 {
  max-height: 400px !important;
}
.usersSpan{
  width: 100%;
  height: 100%;
}
.popover{
  font-size: .75rem;
  max-height: 545px;
  overflow: auto;

  .popover-body {
    padding: 0;
  }
}
.action-button {
  cursor: pointer;
}
</style>